import 'echarts-jsx/dist/renderers/SVG';
import 'echarts-jsx/dist/components/title';
import 'echarts-jsx/dist/components/legend';
import 'echarts-jsx/dist/components/tooltip';
import 'echarts-jsx/dist/components/x-axis';
import 'echarts-jsx/dist/components/y-axis';
import 'echarts-jsx/dist/charts/bar';

import { TSXSample } from '../component/TSXSample';

# Charts in Markdown

This example is based on [ECharts-JSX][1] & [Parcel-transformer-MDX][2].

<TSXSample title='ECharts example'>
    <ec-svg-renderer style={{ height: '80vh' }} onClick={console.log}>
        <ec-title text="ECharts example" />
        <ec-legend data={['sales']} />
        <ec-tooltip />
        <ec-x-axis
            data={[
                'Shirts',
                'Cardigans',
                'Chiffons',
                'Pants',
                'Heels',
                'Socks'
            ]}
        />
        <ec-y-axis />
        <ec-bar-chart
            name="sales"
            data={[5, 20, 36, 10, 10, 20]}
            onClick={console.log}
        />
    </ec-svg-renderer>
</TSXSample>

[1]: https://github.com/idea2app/ECharts-JSX
[2]: https://github.com/EasyWebApp/Parcel-transformer-MDX
